import { EmailLogin, Login, RecoveryPassword } from 'chilogin'

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresGuess: true }
  },
  {
    path: '/email',
    name: 'Email',
    component: EmailLogin,
    meta: { requiresGuess: true }
  },
  {
    path: '/recovery-pàssword',
    name: 'recovery',
    component: RecoveryPassword,
    meta: { requiresGuess: true }
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/router/login.js